import * as React from 'react';
import { useDispatch } from 'react-redux';

import { TThunkDispatch } from '../../../types/redux';
import { newbuildingChatOpenToggle } from '../../state/newbuildingConsultant';
import { NewbuildingConsultBanner } from './NewbuildingConsultBanner';

export function NewbuildingConsultBannerConatiner() {
  const dispatch = useDispatch<TThunkDispatch>();
  const open = React.useCallback(() => dispatch(newbuildingChatOpenToggle(true)), [dispatch]);

  return <NewbuildingConsultBanner onChatClick={open} />;
}
